<template>
  <div class="main-tab">
    <div class="main-tab__player-info">
        <div class="main-tab__player-header">
        <div class="main-tab__image-container relative">
          <img
            @click="uploadPhoto"
            src="@/assets/icons/upload_icon.svg"
            class="main-tab__upload-icon"
          />
          <input
            ref="fileInput"
            type="file"
            class="hidden"
            :value="inputValue"
            accept="image/*"
            @change="handlePhotoChange"
          />
          <img class="main-tab__player-photo" :src="photo" @error="photo = placeholderPhoto" />
        </div>
        <button
          class="main-tab__save-photo"
          :disabled="!hasNewPhoto"
          @click="savePhoto"
        >
          Зберегти фото
        </button>
        <div class="main-tab__name">
          <marquee v-if="name?.length + surname?.length + 1 > 13" behavior="scroll" loop="-1" direction="left">
            <span v-for="id in 100" class="mx-3">{{ name + ' ' + surname }}</span>
          </marquee>
          <span v-else>{{ name + ' ' + surname }}</span>
          <span v-if="name?.length == 0 || surname?.length == 0" style="color: white; opacity: 0.2;">Лєо Мессі</span>
        </div>
        <div class="main-tab__header-row">
          <InfoBlock
            v-for="(infoBlock, index) in infoBlocks"
            :key="index"
            :mainText="infoBlock.mainText"
            :value="infoBlock.value"
            :mainTextPrimary="true"
          />
          <div class="main-tab__origin">
            <img :src="club" alt="" />
            <div class="main-tab__divider"></div>
            <img :src="flag" alt="" />
          </div>
        </div>
      </div>
      <div class="main-tab__player-body mt-[20px] flex flex-col gap-[12px]">
        <div class="flex justify-between">
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 2H14.5V0.5C14.5 0.367392 14.4473 0.240215 14.3536 0.146447C14.2598 0.0526785 14.1326 0 14 0C13.8674 0 13.7402 0.0526785 13.6464 0.146447C13.5527 0.240215 13.5 0.367392 13.5 0.5V2H6.5V0.5C6.5 0.367392 6.44732 0.240215 6.35355 0.146447C6.25979 0.0526785 6.13261 0 6 0C5.86739 0 5.74021 0.0526785 5.64645 0.146447C5.55268 0.240215 5.5 0.367392 5.5 0.5V2H2.5C1.8372 2.00079 1.20178 2.26444 0.73311 2.73311C0.264441 3.20178 0.000793929 3.8372 0 4.5V17.5C0.000793929 18.1628 0.264441 18.7982 0.73311 19.2669C1.20178 19.7356 1.8372 19.9992 2.5 20H17.5C18.1629 19.9995 18.7985 19.7359 19.2672 19.2672C19.7359 18.7985 19.9995 18.1629 20 17.5V4.5C19.9995 3.83712 19.7359 3.20154 19.2672 2.73282C18.7985 2.26409 18.1629 2.00053 17.5 2ZM19 17.5C19 17.8978 18.842 18.2794 18.5607 18.5607C18.2794 18.842 17.8978 19 17.5 19H2.5C2.10218 19 1.72064 18.842 1.43934 18.5607C1.15804 18.2794 1 17.8978 1 17.5V9H19V17.5ZM19 8H1V4.5C1 3.672 1.67 3 2.5 3H5.5V4.5C5.5 4.63261 5.55268 4.75979 5.64645 4.85355C5.74021 4.94732 5.86739 5 6 5C6.13261 5 6.25979 4.94732 6.35355 4.85355C6.44732 4.75979 6.5 4.63261 6.5 4.5V3H13.5V4.5C13.5 4.63261 13.5527 4.75979 13.6464 4.85355C13.7402 4.94732 13.8674 5 14 5C14.1326 5 14.2598 4.94732 14.3536 4.85355C14.4473 4.75979 14.5 4.63261 14.5 4.5V3H17.5C17.8978 3 18.2794 3.15804 18.5607 3.43934C18.842 3.72064 19 4.10218 19 4.5V8Z" fill="#C59014"/>
            </svg>
          </div>
          <div>
            <input type="date" :value="formattedBirthDate" disabled placeholder="Дата народження" class="text-end" />
          </div>
        </div>
        <div class="flex justify-between">
          <div>
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.47943 0.0197962C5.50993 -0.121204 6.37593 0.509296 6.78593 1.3288L7.79443 3.3453C8.35393 4.4643 8.03243 5.7773 7.18443 6.6033C6.68343 7.0908 6.17993 7.6478 5.88793 8.1393C5.86859 8.17433 5.86255 8.21517 5.87093 8.2543C6.14093 9.7173 7.13243 11.1628 8.01693 12.1993C8.06142 12.2487 8.11947 12.2839 8.18385 12.3006C8.24823 12.3172 8.31608 12.3145 8.37893 12.2928L10.3664 11.6718C10.9018 11.5045 11.4767 11.513 12.0069 11.6962C12.537 11.8794 12.9946 12.2276 13.3124 12.6898L14.7509 14.7818C15.1409 15.3498 15.3384 16.1198 15.0394 16.8603C14.7724 17.5218 14.2559 18.4758 13.3164 19.1103C12.3414 19.7683 11.0059 20.0183 9.25843 19.4193C7.30593 18.7493 5.46143 17.0693 3.93193 14.9208C2.39343 12.7588 1.12693 10.0583 0.358931 7.2423C-0.366569 4.5833 0.071431 2.7933 1.10243 1.6408C2.09693 0.528796 3.52193 0.151296 4.47943 0.0197962ZM5.66793 1.8878C5.43943 1.4313 5.03193 1.2058 4.64943 1.2583C3.79893 1.3753 2.73393 1.6918 2.03443 2.4743C1.37143 3.2158 0.912431 4.5218 1.56443 6.9133C2.29693 9.5973 3.50293 12.1623 4.95043 14.1958C6.40693 16.2423 8.06193 17.6873 9.66393 18.2368C11.0914 18.7263 12.0089 18.4843 12.6169 18.0743C13.2599 17.6398 13.6554 16.9493 13.8804 16.3923C13.9834 16.1373 13.9389 15.8073 13.7209 15.4903L12.2824 13.3983C12.116 13.1562 11.8764 12.9738 11.5987 12.8778C11.321 12.7817 11.0199 12.7772 10.7394 12.8648L8.75193 13.4858C8.15793 13.6713 7.48893 13.5058 7.06643 13.0108C6.14593 11.9323 4.97293 10.2783 4.64143 8.4808C4.57806 8.14392 4.63919 7.79549 4.81343 7.5003C5.19243 6.8633 5.79243 6.2138 6.31193 5.7078C6.81943 5.2138 6.96343 4.4788 6.67643 3.9043L5.66793 1.8883V1.8878Z" fill="#C59014"/>
            </svg>

          </div>
          <div>
            <input :value="phoneNumber" type="text" disabled placeholder="Номер" class="text-end" />
          </div>
        </div>
        <div class="flex justify-between">
          <div>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.6134 9.08897L1.11341 0.838974C0.984092 0.7743 0.838831 0.748386 0.695123 0.764353C0.551414 0.780321 0.415385 0.837489 0.303414 0.928974C0.196482 1.01859 0.116669 1.13626 0.0729463 1.26876C0.0292236 1.40125 0.0233252 1.54331 0.0559143 1.67897L2.27591 9.75647L0.0259143 17.8115C-0.00466584 17.9248 -0.00823548 18.0437 0.0154925 18.1586C0.0392205 18.2735 0.0895842 18.3812 0.162534 18.4732C0.235483 18.5651 0.328982 18.6386 0.435514 18.6878C0.542046 18.737 0.658638 18.7605 0.775914 18.7565C0.893321 18.7558 1.00892 18.7275 1.11341 18.674L17.6134 10.424C17.7363 10.361 17.8394 10.2654 17.9114 10.1476C17.9833 10.0299 18.0214 9.89451 18.0214 9.75647C18.0214 9.61844 17.9833 9.48308 17.9114 9.36531C17.8394 9.24753 17.7363 9.15191 17.6134 9.08897ZM1.93841 16.589L3.59591 10.5065H10.5259V9.00647H3.59591L1.93841 2.92397L15.5959 9.75647L1.93841 16.589Z" fill="#C59014"/>
            </svg>

          </div>
          <div>
            <input :value="email" type="text" disabled placeholder="Email" class="text-end" />
          </div>
        </div>
        <div class="flex justify-between">
          <div>
            <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.4881 3.43164L17.8569 0.787891H17.8475L17.8194 0.76914H17.7631C17.7631 0.759765 17.7538 0.759766 17.7444 0.759766H14.5756C14.4265 0.759766 14.2834 0.819029 14.1779 0.924518C14.0724 1.03001 14.0131 1.17308 14.0131 1.32227C14.0131 1.96873 13.7563 2.58872 13.2992 3.04584C12.8421 3.50296 12.2221 3.75977 11.5756 3.75977C10.9292 3.75977 10.3092 3.50296 9.85207 3.04584C9.39495 2.58872 9.13814 1.96873 9.13814 1.32227C9.13814 1.17308 9.07888 1.03001 8.97339 0.924518C8.8679 0.819029 8.72483 0.759766 8.57564 0.759766H5.40689C5.39752 0.759766 5.38814 0.759765 5.38814 0.76914H5.33189L5.30377 0.787891H5.29439L0.663143 3.43164C0.371172 3.59946 0.154262 3.87239 0.0566947 4.19471C-0.040873 4.51704 -0.0117411 4.86444 0.138143 5.16602L1.86314 8.61602C1.9725 8.83303 2.13996 9.01543 2.34687 9.14289C2.55377 9.27034 2.79201 9.33785 3.03502 9.33789H5.01314V17.0254C5.01314 17.3735 5.15142 17.7073 5.39757 17.9535C5.64371 18.1996 5.97755 18.3379 6.32564 18.3379H16.8256C17.1737 18.3379 17.5076 18.1996 17.7537 17.9535C17.9999 17.7073 18.1381 17.3735 18.1381 17.0254V9.33789H20.1163C20.3593 9.33785 20.5975 9.27034 20.8044 9.14289C21.0113 9.01543 21.1788 8.83303 21.2881 8.61602L23.0131 5.16602C23.163 4.86444 23.1922 4.51704 23.0946 4.19471C22.997 3.87239 22.7801 3.59946 22.4881 3.43164ZM3.03502 8.21289C3.00117 8.21367 2.96788 8.20425 2.93946 8.18586C2.91103 8.16747 2.8888 8.14096 2.87564 8.10977L1.15064 4.65977C1.1389 4.63946 1.13128 4.61704 1.12822 4.59379C1.12516 4.57054 1.12673 4.54691 1.13283 4.52426C1.13892 4.50161 1.14943 4.48039 1.16375 4.46182C1.17807 4.44324 1.19592 4.42768 1.21627 4.41602L5.01314 2.24102V8.21289H3.03502ZM17.0131 17.0254C17.0131 17.0751 16.9934 17.1228 16.9582 17.158C16.9231 17.1931 16.8754 17.2129 16.8256 17.2129H6.32564C6.27592 17.2129 6.22822 17.1931 6.19306 17.158C6.1579 17.1228 6.13814 17.0751 6.13814 17.0254V1.83789H8.06002C8.19664 2.67176 8.62521 3.42991 9.2692 3.97697C9.91319 4.52403 10.7307 4.82438 11.5756 4.82438C12.4206 4.82438 13.2381 4.52403 13.8821 3.97697C14.5261 3.42991 14.9546 2.67176 15.0913 1.83789H17.0131V17.0254ZM22.0006 4.65977L20.2756 8.10977C20.2625 8.14096 20.2403 8.16747 20.2118 8.18586C20.1834 8.20425 20.1501 8.21367 20.1163 8.21289H18.1381V2.24102L21.935 4.41602C21.9554 4.42768 21.9732 4.44324 21.9875 4.46182C22.0019 4.48039 22.0124 4.50161 22.0185 4.52426C22.0246 4.54691 22.0261 4.57054 22.0231 4.59379C22.02 4.61704 22.0124 4.63946 22.0006 4.65977Z" fill="#C59014"/>
            </svg>

          </div>
          <div>
            <input type="text" placeholder="Розмір одягу" class="text-end" />
          </div>
        </div>
        <div class="flex justify-between">
          <div>
            <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9135 6.65727V0.759766H16.9135V6.65727C16.9135 7.59227 17.237 8.51627 17.639 9.46977C17.9205 10.1378 18.164 10.9523 18.164 11.7598C18.1635 12.9343 17.6365 13.7123 16.941 14.1758C16.273 14.6208 15.48 14.7598 14.9135 14.7598C14.23 14.7598 13.78 14.6138 13.3995 14.4273C13.282 14.3698 13.161 14.3023 13.055 14.2438C13.0085 14.2178 12.965 14.1938 12.9255 14.1728C12.7914 14.0977 12.6508 14.0346 12.5055 13.9843C12.3685 13.9383 12.072 13.9063 11.6575 13.8998C11.2635 13.8938 10.8225 13.9108 10.4355 13.9333C10.012 13.9578 9.63602 14.1083 9.17552 14.2933C9.03502 14.3493 8.88602 14.4088 8.72552 14.4693C8.25052 14.6473 7.61902 14.7598 6.66352 14.7598C5.67202 14.7598 5.19852 14.7028 4.87302 14.5633C4.7633 14.5141 4.65864 14.4543 4.56052 14.3848C4.53052 14.3645 4.50001 14.345 4.46902 14.3263C4.32525 14.4247 4.16701 14.5001 4.00002 14.5498C3.59002 14.6778 2.92052 14.7598 1.66352 14.7598C1.23452 14.7598 0.86652 14.6568 0.57952 14.4398C0.29152 14.2213 0.134521 13.9258 0.0605206 13.6333C-0.0819794 13.0758 0.0535206 12.4628 0.195521 12.0843C0.231239 11.989 0.295181 11.9069 0.378807 11.8489C0.462432 11.7909 0.561759 11.7598 0.663521 11.7598H2.48852L2.80202 11.5088C3.38452 11.0428 4.04702 10.7168 4.71852 10.4768C5.58502 10.1668 6.68252 9.69177 7.67752 9.06027C8.64952 8.44327 9.47752 7.70527 9.92502 6.86627L10.416 1.71227L11.411 1.80727L10.911 7.05727C10.9053 7.11851 10.8884 7.17818 10.861 7.23327C10.307 8.34077 9.28202 9.22627 8.21352 9.90477C7.13702 10.5883 5.96652 11.0923 5.05502 11.4183C4.45502 11.6333 3.89852 11.9118 3.42652 12.2893L3.11302 12.5408C2.93561 12.6826 2.71518 12.7599 2.48802 12.7598H1.03902C0.99502 12.9768 0.98302 13.2058 1.02902 13.3863C1.06102 13.5103 1.11402 13.5898 1.18302 13.6423C1.25402 13.6963 1.39302 13.7598 1.66352 13.7598C2.90652 13.7598 3.44552 13.6748 3.70202 13.5948C3.81502 13.5598 3.86802 13.5263 3.90802 13.4988L3.92402 13.4868C3.96702 13.4538 4.08302 13.3658 4.19002 13.3128C4.30852 13.2534 4.44573 13.2435 4.57152 13.2853C4.80652 13.3638 4.95402 13.4468 5.07352 13.5248L5.15752 13.5803C5.20802 13.6143 5.22652 13.6268 5.26652 13.6438C5.37852 13.6918 5.65502 13.7598 6.66352 13.7598C7.54452 13.7598 8.04702 13.6553 8.37452 13.5328C8.48202 13.4928 8.59602 13.4463 8.71552 13.3978C9.19852 13.2028 9.77402 12.9698 10.3775 12.9348C10.8088 12.9078 11.2409 12.8961 11.673 12.8998C12.081 12.9063 12.521 12.9348 12.8215 13.0353C13.048 13.1108 13.2355 13.2038 13.4 13.2923L13.571 13.3863C13.6635 13.4378 13.7445 13.4828 13.84 13.5298C14.097 13.6558 14.397 13.7598 14.9135 13.7598C15.347 13.7598 15.9285 13.6488 16.386 13.3438C16.816 13.0573 17.1635 12.5848 17.1635 11.7598C17.1635 11.1378 16.972 10.4623 16.7175 9.85827C16.31 8.89127 15.9135 7.80727 15.9135 6.65727Z" fill="#C59014"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1626 7.25977C14.2952 7.25977 14.4224 7.31244 14.5161 7.40621C14.6099 7.49998 14.6626 7.62716 14.6626 7.75977H14.1626H14.6626V7.77077L14.6621 7.79077C14.6621 7.80627 14.6606 7.82777 14.6591 7.85427C14.6378 8.16288 14.5778 8.46761 14.4806 8.76127C14.3006 9.30327 13.9286 9.98327 13.1696 10.4388C13.0558 10.507 12.9196 10.5272 12.7909 10.495C12.6622 10.4628 12.5516 10.3808 12.4833 10.267C12.4151 10.1532 12.3949 10.017 12.4271 9.88832C12.4593 9.75962 12.5413 9.64899 12.6551 9.58077C13.1466 9.28627 13.4001 8.84127 13.5321 8.44577C13.6016 8.23573 13.6449 8.01792 13.6611 7.79727L13.6626 7.76327V7.75727C13.6632 7.62509 13.7162 7.49856 13.8099 7.40533C13.9036 7.3121 14.0304 7.25976 14.1626 7.25977Z" fill="#C59014"/>
            </svg>

          </div>
          <div>
            <input type="text" :value="student.leading_foot" disabled placeholder="Нога" class="text-end" />
          </div>
        </div>
        <div class="flex justify-between">
          <div>
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.622 6.08102L14.6813 1.1404C14.434 0.8965 14.1006 0.759766 13.7532 0.759766C13.4059 0.759766 13.0724 0.8965 12.8251 1.1404L0.38447 13.581C0.262579 13.7029 0.165889 13.8476 0.0999209 14.0068C0.0339532 14.1661 0 14.3368 0 14.5091C0 14.6815 0.0339532 14.8522 0.0999209 15.0115C0.165889 15.1707 0.262579 15.3154 0.38447 15.4373L5.3251 20.3779C5.44697 20.4998 5.59167 20.5965 5.75092 20.6624C5.91017 20.7284 6.08085 20.7624 6.25322 20.7624C6.42559 20.7624 6.59627 20.7284 6.75552 20.6624C6.91477 20.5965 7.05947 20.4998 7.18135 20.3779L19.622 7.93727C19.7439 7.81539 19.8406 7.6707 19.9065 7.51145C19.9725 7.3522 20.0064 7.18152 20.0064 7.00915C20.0064 6.83678 19.9725 6.66609 19.9065 6.50685C19.8406 6.3476 19.7439 6.2029 19.622 6.08102ZM18.8251 7.1404L6.38447 19.581C6.36778 19.5992 6.3475 19.6137 6.32491 19.6237C6.30231 19.6336 6.2779 19.6387 6.25322 19.6387C6.22854 19.6387 6.20413 19.6336 6.18153 19.6237C6.15894 19.6137 6.13866 19.5992 6.12197 19.581L1.18134 14.6404C1.16316 14.6237 1.14864 14.6034 1.13871 14.5808C1.12877 14.5582 1.12364 14.5338 1.12364 14.5091C1.12364 14.4845 1.12877 14.4601 1.13871 14.4375C1.14864 14.4149 1.16316 14.3946 1.18134 14.3779L3.62822 11.931L6.23447 14.5279C6.28618 14.5796 6.34756 14.6206 6.41512 14.6486C6.48268 14.6766 6.55509 14.691 6.62822 14.691C6.70135 14.691 6.77376 14.6766 6.84132 14.6486C6.90888 14.6206 6.97026 14.5796 7.02197 14.5279C7.07368 14.4762 7.1147 14.4148 7.14268 14.3472C7.17066 14.2797 7.18507 14.2073 7.18507 14.1341C7.18507 14.061 7.17066 13.9886 7.14268 13.9211C7.1147 13.8535 7.07368 13.7921 7.02197 13.7404L4.4251 11.1341L7.00322 8.55602L9.60947 11.1529C9.66118 11.2046 9.72256 11.2456 9.79012 11.2736C9.85769 11.3016 9.93009 11.316 10.0032 11.316C10.0763 11.316 10.1488 11.3016 10.2163 11.2736C10.2839 11.2456 10.3453 11.2046 10.397 11.1529C10.4487 11.1012 10.4897 11.0398 10.5177 10.9722C10.5457 10.9047 10.5601 10.8323 10.5601 10.7591C10.5601 10.686 10.5457 10.6136 10.5177 10.5461C10.4897 10.4785 10.4487 10.4171 10.397 10.3654L7.8001 7.75915L10.3782 5.18102L12.9845 7.7779C13.0362 7.82961 13.0976 7.87062 13.1651 7.89861C13.2327 7.92659 13.3051 7.94099 13.3782 7.94099C13.4513 7.94099 13.5238 7.92659 13.5913 7.89861C13.6589 7.87062 13.7203 7.82961 13.772 7.7779C13.8237 7.72619 13.8647 7.6648 13.8927 7.59724C13.9207 7.52968 13.9351 7.45727 13.9351 7.38415C13.9351 7.31102 13.9207 7.23861 13.8927 7.17105C13.8647 7.10349 13.8237 7.04211 13.772 6.9904L11.1751 4.38415L13.622 1.93727C13.6387 1.91909 13.6589 1.90457 13.6815 1.89463C13.7041 1.8847 13.7285 1.87957 13.7532 1.87957C13.7779 1.87957 13.8023 1.8847 13.8249 1.89463C13.8475 1.90457 13.8678 1.91909 13.8845 1.93727L18.8251 6.8779C18.8433 6.89458 18.8578 6.91487 18.8677 6.93746C18.8777 6.96006 18.8828 6.98447 18.8828 7.00915C18.8828 7.03383 18.8777 7.05824 18.8677 7.08083C18.8578 7.10343 18.8433 7.12371 18.8251 7.1404Z" fill="#C59014"/>
            </svg>

          </div>
          <div>
            <input type="text" :value="student.height" disabled placeholder="Зріст" class="text-end" />
          </div>
        </div>
        <!-- <InputHorizontal
          label="ім'я"
          name="first_name"
          placeholder="Введіть ім'я"
          :value="name"
        />
        <InputHorizontal
          label="прізвище"
          name="last_name"
          placeholder="Введіть прізвище"
          :value="surname"
        />
        <InputHorizontal
          label="по батькові"
          name="middle_name"
          placeholder="Введіть по батькові"
          :value="patronymic"
        />
        <InputHorizontal
          label="дата нр."
          type="date"
          name="birth_date"

          :value="formattedBirthDate"
        />
        <InputHorizontal
          label="телефон"
          name="phone_number"
          placeholder="Введіть телефон"
          :value="phoneNumber"
        />
        <InputHorizontal
          label="email"
          name="email"
          placeholder="Введіть email"
          :value="email"
        />
        <InputHorizontal
          label="національність"
          name="nationality"
          placeholder="Введіть національність"
          :value="nationality"
        /> -->
        <div>
          <training-calendar 
            :planedTrainings="planedTrainingsData"
            :completedTrainings="completedTrainingsByGroup"
            :attendedTrainings="studentAttendedTrainings"
            :missedTrainings="studentMissedTrainings"
          />
        </div>
        <IconButton @click="$emit('close')" :src="arrow" :fullWidth="true" />
      </div>
    </div>

    <div class="main-tab__block-text main-tab__block--career">
      <div class="main-tab__title">Кар'єра</div>
      <div class="main-tab__list">
        <InfoLine
          v-for="(value, key) in career"
          :key="key"
          :label="value.time"
          :value="value.team"
        />
      </div>
    </div>

    <div class="main-tab__block main-tab__block--position">
      <div class="main-tab__title">Амплуа</div>
      <PositionsField :playerAmplua="studentAmplua" :playerNumber="studentNumber"  />
    </div>

    <div class="main-tab__block main-tab__block--trainings">
      <div class="main-tab__title">Тренування</div>
      <!-- <img :src="progress" alt="Block 2 Image" /> -->
       <PieChartDashboard :percent="attendanceCoeff" :key="attendanceCoeff"/>
    </div>

    <div class="main-tab__block-text main-tab__block--finances">
      <div class="main-tab__title">Фінанси</div>
      <!-- <div class="main-tab__list">
        <InfoLine :label="'непрямі витрати'">
          <CurrencyComponent :value="finances.total_expense" :textNormal="true"
        /></InfoLine>
        <InfoLine :label="'прямі витрати'">
          <CurrencyComponent :value="finances.total_expense" :textNormal="true"
        /></InfoLine>
        <InfoLine :label="'загальні витрати'">
          <CurrencyComponent :value="finances.total_expense" :textNormal="true"
        /></InfoLine>
      </div> -->
      <div class="text-center text-gray-500">
        В розробці
      </div>
    </div>

    <div class="main-tab__block main-tab__block--analysis">
      <div class="main-tab__title">Аналіз гравця</div>
      <!-- <img :src="graph" alt="Block 2 Image" /> -->
      <!-- <RadarChart :chartData="[1, 3, 4, 5,1, 3, 4, 5,1,]" :chart-size="{ width: '250px', height: '220px' }" /> -->
      <RadarChart :chartData="marks" :indicators="radarSettings" :key="chartKey" :max="10" :chart-size="{ width: '270px', height: '220px' }" />
    </div>

    <div class="main-tab__block main-tab__block--matches-played">
      <div class="main-tab__title">Зіграно матчів</div>
      <PieChartDashboard :percent="playerMatchPercent || 0" :key="playerMatchPercent"/>
    </div>

    <div class="main-tab__block-text main-tab__block--health">
      <div class="main-tab__title">Медицина</div>
      <div class="main-tab__list">
        <InfoLine :label="'група крові'" :value="playerHealth.blood_group" />
        <InfoLine :label="'зріст'" :value="student.height" />
        <InfoLine :label="'вага'" :value="student.weight" />
        <InfoLine
          :label="'BMI'"
          :value="calculateBMI(student.weight, student.height)"
        />
      </div>
    </div>

    <div class="main-tab__block main-tab__block--parameters">
      <div class="main-tab__title">Травми</div>
      <div class="flex justify-center scale-[0.8] h-[100px] relative top-[-10px]">
        <MiniSkeletonBack :selectedParts="playerCurrentStatus.backBodyInjuredParts" />
        <MiniSkeletonFront :selectedParts="playerCurrentStatus.frontBodyInjuredParts" />
      </div>
    </div>
    <div class="main-tab__block main-tab__block--minutes-played">
      <div class="main-tab__title">Зіграно хвилин</div>
      <PieChartDashboard :percent="playerMatchTime || 0" :key="playerMatchTime"/>
    </div>
    <div class="main-tab__table">
      <div class="main-tab__title">Статистика</div>
      <TableWrapper style="margin-top: -10px !important">
        <TableComponent>
          <TableHeader>
            <TableHeaderRow>
              <TableHeaderCell :value="' '" :width="50" :borderNone="true" />
              <TableHeaderCell
                v-for="headerCell in table.header"
                :key="headerCell"
                :value="headerCell"
                :borderNone="true"
                :width="10"
              />
            </TableHeaderRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell
                style="padding: 5px !important"
                :value="'попередні клуби'"
                :width="30"
                :borderNone="true"
                :fontPrimary="true"
                :textAlign="'start'"
              />
              <TableCell
                style="padding: 5px !important"
                v-for="(value, key) in table.before_joining"
                :value="value"
                :key="key"
                :borderNone="true"
              />
            </TableRow>
            <TableRow>
              <TableCell
                style="padding: 5px !important"
                :value="'в клубі'"
                :width="30"
                :borderNone="true"
                :font-primary="true"
                :textAlign="'start'"
              />
              <TableCell
                style="padding: 5px !important"
                v-for="(value, key) in Object.values(playerMatchSummaryStats)"
                :value="value"
                :key="key"
                :borderNone="true"
              />
            </TableRow>
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell
                style="padding: 5px !important"
                :value="'загалом'"
                :width="30"
                :borderNone="true"
                :font-primary="true"
                :textAlign="'start'"
              />
              <TableCell
                style="padding: 5px !important"
                v-for="(value, key) in Object.values(allSummaryStats)"
                :value="value"
                :key="key"
                :borderNone="true"
                :width="5"
              />
            </TableRow>
          </TableFooter>
        </TableComponent>
      </TableWrapper>
    </div>
    <div class="main-tab__block-text main-tab__block--testing">
      <div class="main-tab__title">Показники</div>
      <div class="main-tab__list mt-[24px]" style="max-height: none;">
        <InfoLine
          style="margin-bottom: 4px;"
          :label="'Середня дистанція'"
          :value="averagePoints[0] ? +averagePoints[0].toFixed(2) : '-'"
        />
        <InfoLine
          style="margin-bottom: 4px;"
          :label="'Швидкісний метраж'"
          :value="averagePoints[7] ? +averagePoints[7].toFixed(2) : '-'"
        />
        <InfoLine style="margin-bottom: 4px;" :label="'Максимальна швидкість'" :value="averagePoints[1] ? +averagePoints[1].toFixed(2) : '-'" />
        <InfoLine style="margin-bottom: 4px;" :label="'Загальна оцінка'">
          <StarsComponent :rating="(marks.reduce(
            (acc, mark) => acc + (mark || 0),
            0
          ) / marks.length)?.toFixed(2)" class="origin-right"/>
        </InfoLine>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { getStudentCompletedTrainings, getSummaryPlayerStats, getGpsReportByMatchId, getPlayerStatisticsByPlayerId, getPlayerTimeAndMatchCount, getAllMatchesByGroupId, getPlayerHealthStatus, getAllCompletedTrainingsByStudentId, getAverageScoreByStudentId, getPlanedTrainingsByGroupId, getCompletedTrainingsByGroupId, getPlayerHealthParamsByStudentId } from "@/services/apiRequests";
import graph from "@/assets/refactored_assets/img/players/player-graph.png";
import body from "@/assets/refactored_assets/img/players/body.png";
import field from "@/assets/refactored_assets/img/players/field.png";
import arrow from "@/assets/refactored_assets/img/header/arrow.svg";
import progress from "@/assets/refactored_assets/img/players/progress.png";
import player_image from "@/assets/refactored_assets/img/header/player.png";
import club from "@/assets/refactored_assets/img/players/kolos_logo.svg";
import flag from "@/assets/refactored_assets/img/header/flag.png";
import PositionsField from "../widgets/PositionsField.vue";
import PlayerModel from "../widgets/PlayerModel.vue";
import TrainingCalendar from "../widgets/TrainingCalendar/TrainingCalendar.vue";

import MiniSkeletonBack from "../widgets/MiniSkeletonBack.vue";
import MiniSkeletonFront from "../widgets/MiniSkeletonFront.vue";

import PieChartDashboard from "../widgets/PieChartDashboard.vue";

import { useGlobalStore } from '@/storage/globalStorage'

export default {
  name: "MainTab",

  props: {
    student: {
      type: Object,
      required: true,
    },
    fullCardInfo: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const apiURL = ref(process.env.VUE_APP_API_URL);
    const placeholderPhoto = require('@/assets/student-photo-placeholder-tpbg.png')
    const store = useGlobalStore()
    const fileInput = ref(null)
    const inputValue = ref(null)
    const name = ref(
      props.student?.name ? props.student.name : ''
    )
    const surname = ref(
      props.student?.surname ? props.student.surname : ''
    )
    const patronymic = ref(
      props.student?.patronymic ? props.student.patronymic : ''
    )
    const formattedBirthDate = ref(
      props.student?.birth_date ? props.student.birth_date.split : ''
    )
    const email = ref(
      props.student?.email ? props.student.email : ''
    )
    const phoneNumber = ref(
      props.student?.phone ? props.student.phone : ''
    )
    const nationality = ref(
      props.student?.nationality ? props.student.nationality : ''
    )
    const group = ref(
      props.student?.group_name ? props.student.group_name : ''
    )
    const age = ref(
      props.student?.age ? props.student.age : ''
    )
    const studentAmplua = ref(
      props.student?.amplua ? props.student.amplua : ''
    )
    const studentNumber = ref(
      props.student?.player_number ? props.student.player_number : ''
    )
    const photo = ref(
      props.student?.photo_preview
        ? props.student.photo_preview
        : props.student?.photo
          ? apiURL.value + 'static/' + props.student.photo
          : placeholderPhoto
    )

    const uploadPhoto = () => {
      fileInput.value?.click()
    }

    const handlePhotoChange = (event) => {
      emit('loadPhoto', event)
    }

    const hasNewPhoto = computed(() => !!props.student.photo_preview)

    const savePhoto = () => {
      if (hasNewPhoto.value) {
        emit('savePhoto')
      }
    }

    const infoBlocks = ref([
      {
        mainText: "Група",
        value: group.value,
      },
      {
        mainText: "Вік",
        value: age.value,
      },
      {
        mainText: "Амплуа",
        value: studentAmplua.value,
      },
      {
        mainText: "Номер",
        value: studentNumber.value,
      },
    ])

    const career = ref(props.fullCardInfo.career.map((item) => {
      return {
        time: item.time,
        team: item.club,
      }
    }))

    const studentAttendedTrainings = ref([])
    const studentMissedTrainings = ref([])
    const planedTrainingsData = ref([])
    const completedTrainingsByGroup = ref([])

    const playerHealth = ref({})

    const marks = ref(Array(7).fill(null));
    const chartKey = ref(new Date().getTime()); 
    const radarSettings = ref(props.student.amplua == 'ВР' ? Object.values(store.$state.scoringRadarChartSettings.goalkeeper).slice(2).filter(value => value !== null).map(e => ({name: e, max: 10})) : Object.values(store.$state.scoringRadarChartSettings.field_player).slice(2).filter(value => value !== null).map(e => ({name: e, max: 10})));

    const getMatchRating = async () => {
      const matchRating = await getAverageScoreByStudentId(props.student.student_id);
      return matchRating;
    }

    const playerCurrentStatus = ref({});

    const attendanceCoeff = ref(undefined)

    const getAttendanceCoeff = async (student_id) => {
      const trainingsRes = await getAllCompletedTrainingsByStudentId(student_id)

      let percentTrainingsAttended = trainingsRes.trainings_attended.length * 100 / (trainingsRes.trainings_attended.length + trainingsRes.missed_trainings.length)
      percentTrainingsAttended = percentTrainingsAttended ? percentTrainingsAttended : 0

      attendanceCoeff.value = percentTrainingsAttended.toFixed(2)
    }

    const allMatchesCount = ref(0)
    const playerMatchesCount = ref(0)
    const playerMatchPercent = ref(undefined)
    const playerMatchTime = ref(undefined)

    const playerMatchSummaryStats = ref(['-', '-', '-', '-', '-', '-', '-', '-', '-'])
    const allSummaryStats = ref(['-', '-', '-', '-', '-', '-', '-', '-', '-'])

    const allMatches = ref([])
    const gpsReports = ref([])
    const reportsMarks = ref([])
    const averagePoints = ref(0)
    const summPoints = ref(0)
    const maxPoints = ref(0)
    const minPoints = ref(0)

    onMounted(async () => {
      if (!props.student?.photo) {
        photo.value = placeholderPhoto
      }
      console.log('props.student', props.fullCardInfo)

      const res = await getStudentCompletedTrainings(props.student.student_id)
      studentAttendedTrainings.value = res.data?.trainings_attended ?? []
      studentMissedTrainings.value = res.data?.missed_trainings ?? []
      
      if (props.student.group_id) {
        const planedTrainingsRes = await getPlanedTrainingsByGroupId(props.student.group_id)
        planedTrainingsData.value = planedTrainingsRes.data
      } else {
        planedTrainingsData.value = []
      }
      const resCompleted = await getCompletedTrainingsByGroupId(props.student.group_id)
      completedTrainingsByGroup.value = resCompleted.data

      const resHealth = await getPlayerHealthParamsByStudentId(props.student.student_id)
      playerHealth.value = resHealth
      console.log('playerHealth', playerHealth.value)

      const matchRatingPoints = await getMatchRating();
      console.log('matchRatingPoints', matchRatingPoints);
      marks.value = matchRatingPoints;

      chartKey.value = new Date().getTime();

      playerCurrentStatus.value = await getPlayerHealthStatus(props.student.student_id)

      await getAttendanceCoeff(props.student.student_id)

      const playerMatchStats = await getPlayerTimeAndMatchCount(props.student.student_id)
      console.log('playerMatchStats', playerMatchStats)

      allMatchesCount.value = await getAllMatchesByGroupId(props.student.group_id)

      console.log('allMatchesCount.value', allMatchesCount.value)
      playerMatchesCount.value = playerMatchStats.matches_count
      playerMatchPercent.value = playerMatchesCount.value * 100 / allMatchesCount.value.length
      
      const allMatchTime = allMatchesCount.value.reduce((acc, match) => acc + +match.matchTime, 0)
      playerMatchTime.value = playerMatchStats.average_game_time * 100 / allMatchTime

      playerMatchSummaryStats.value = await getSummaryPlayerStats(props.student.student_id)
      allSummaryStats.value = playerMatchSummaryStats.value

      allMatches.value = await getPlayerStatisticsByPlayerId(props.student.student_id);
      console.log(allMatches.value);

      allMatches.value = allMatches.value.map((match) => {
        reportsMarks.value.push(match.player_average_score);
        
        return {
          id: match.match_report_id,
          date: {
            day: match.date.split('T')[0].split('-').reverse().join('.'),
            time: match.time,
          },
          match: match.firstTeamName + " - " + match.secondTeamName,
          league: match.league,
          season: match.season,
          goals: match.player_goals,
          assists: match.player_assist,
          penalty: match.player_penalty,
          autoGoal: match.player_autogoals,
          duration: match.player_game_time,
          cards: {
            yellow: match.player_yellow_card,
            red: match.player_red_card,
          },
          rating: match?.player_match_reports ? match?.player_match_reports?.reduce((acc, report) => acc + report.rating, 0) / match.player_match_reports.length : 0,
          trauma: '',
        };
      });


      for (let i = 0; i < allMatches.value.length; i++) {
        console.log('allMatches.value[i].match_report_id -------> ', allMatches.value[i]);
        const gpsRes = await getGpsReportByMatchId(allMatches.value[i].id);
      
        if (gpsRes.gps_report) {
          const maybeStartPlayer = gpsRes.gps_report.gps_reports_list.start_players.find((player) => player.playerId === props.student.student_id);
          const maybeReservePlayer = gpsRes.gps_report.gps_reports_list.reserve_players.find((player) => player.playerId === props.student.student_id);

          if (maybeStartPlayer) {
            gpsReports.value.push({
              ...maybeStartPlayer,
              match: allMatches.value[i].match,
              date: allMatches.value[i].date,
            });
          } else if (maybeReservePlayer) {
            gpsReports.value.push({
              ...maybeReservePlayer,
              match: allMatches.value[i].match,
              date: allMatches.value[i].date,
            });
          }
        }

        // gpsReports.value.push(gpsRes);
      }

      let allFirst_gps_point = gpsReports.value.map(player => player.player_gps_data.first_gps_point?.quantityType != 'time' ? +player.player_gps_data.first_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.first_gps_point.value));
      let allSecond_gps_point = gpsReports.value.map(player => player.player_gps_data.second_gps_point?.quantityType != 'time' ? +player.player_gps_data.second_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.second_gps_point.value));
      let allThird_gps_point = gpsReports.value.map(player => player.player_gps_data.third_gps_point?.quantityType != 'time' ? +player.player_gps_data.third_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.third_gps_point.value));
      let allFourth_gps_point = gpsReports.value.map(player => player.player_gps_data.fourth_gps_point?.quantityType != 'time' ? +player.player_gps_data.fourth_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.fourth_gps_point.value));
      let allFifth_gps_point = gpsReports.value.map(player => player.player_gps_data.fifth_gps_point?.quantityType != 'time' ? +player.player_gps_data.fifth_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.fifth_gps_point.value));
      let allSixth_gps_point = gpsReports.value.map(player => player.player_gps_data.sixth_gps_point?.quantityType != 'time' ? +player.player_gps_data.sixth_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.sixth_gps_point.value));
      let allSeventh_gps_point = gpsReports.value.map(player => player.player_gps_data.seventh_gps_point?.quantityType != 'time' ? +player.player_gps_data.seventh_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.seventh_gps_point.value));
      let allEighth_gps_point = gpsReports.value.map(player => player.player_gps_data.eighth_gps_point?.quantityType != 'time' ? +player.player_gps_data.eighth_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.eighth_gps_point.value));
      let allNineth_gps_point = gpsReports.value.map(player => player.player_gps_data.nineth_gps_point?.quantityType != 'time' ? +player.player_gps_data.nineth_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.nineth_gps_point.value));
      let allTenth_gps_point = gpsReports.value.map(player => player.player_gps_data.tenth_gps_point?.quantityType != 'time' ? +player.player_gps_data.tenth_gps_point.value?.replace(',', '.') : timeStringToSecond(player.player_gps_data.tenth_gps_point.value));

      allFirst_gps_point = allFirst_gps_point.filter(value => value);
      allSecond_gps_point = allSecond_gps_point.filter(value => value);
      allThird_gps_point = allThird_gps_point.filter(value => value);
      allFourth_gps_point = allFourth_gps_point.filter(value => value);
      allFifth_gps_point = allFifth_gps_point.filter(value => value);
      allSixth_gps_point = allSixth_gps_point.filter(value => value);
      allSeventh_gps_point = allSeventh_gps_point.filter(value => value);
      allEighth_gps_point = allEighth_gps_point.filter(value => value);
      allNineth_gps_point = allNineth_gps_point.filter(value => value);
      allTenth_gps_point = allTenth_gps_point.filter(value => value);

      averagePoints.value = [
        allFirst_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allFirst_gps_point.filter(value => value).length || 0,
        allSecond_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allSecond_gps_point.filter(value => value).length || 0,
        allThird_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allThird_gps_point.filter(value => value).length || 0,
        allFourth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allFourth_gps_point.filter(value => value).length || 0,
        allFifth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allFifth_gps_point.filter(value => value).length || 0,
        allSixth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allSixth_gps_point.filter(value => value).length || 0,
        allSeventh_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allSeventh_gps_point.filter(value => value).length || 0,
        allEighth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allEighth_gps_point.filter(value => value).length || 0,
        allNineth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allNineth_gps_point.filter(value => value).length || 0,
        allTenth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) / allTenth_gps_point.filter(value => value).length || 0,
      ];

      console.log('averagePoints.value', averagePoints.value)

      summPoints.value = [
        allFirst_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
        allSecond_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
        allThird_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
        allFourth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
        allFifth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
        allSixth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
        allSeventh_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
        allEighth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
        allNineth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
        allTenth_gps_point.filter(value => value).reduce((acc, value) => acc + +value, 0) || 0,
      ];

      maxPoints.value = [
        Math.max(...allFirst_gps_point),
        Math.max(...allSecond_gps_point),
        Math.max(...allThird_gps_point),
        Math.max(...allFourth_gps_point),
        Math.max(...allFifth_gps_point),
        Math.max(...allSixth_gps_point),
        Math.max(...allSeventh_gps_point),
        Math.max(...allEighth_gps_point),
        Math.max(...allNineth_gps_point),
        Math.max(...allTenth_gps_point),
      ];

      minPoints.value = [
        Math.min(...allFirst_gps_point),
        Math.min(...allSecond_gps_point),
        Math.min(...allThird_gps_point),
        Math.min(...allFourth_gps_point),
        Math.min(...allFifth_gps_point),
        Math.min(...allSixth_gps_point),
        Math.min(...allSeventh_gps_point),
        Math.min(...allEighth_gps_point),
        Math.min(...allNineth_gps_point),
        Math.min(...allTenth_gps_point),
      ];

    })

    watch([() => props.student.photo, () => props.student.photo_preview], ([newPhoto, newPreview]) => {
      const candidate = newPreview || newPhoto
      if (candidate && candidate !== 'null') {
        photo.value = candidate.startsWith('blob:') || candidate.startsWith('http')
          ? candidate
          : apiURL.value + 'static/' + candidate
      } else {
        photo.value = placeholderPhoto
      }
      inputValue.value = null
    })

    const calculateBMI = (weight, height) => {
      if (weight <= 0 || height <= 0) {
        return 0;
      }

      const bmi = weight / ((height / 100) ** 2);
      return parseFloat(bmi.toFixed(2)); // Округляем результат до двух знаков после запятой
    }

    return {
      name,
      surname,
      patronymic,
      formattedBirthDate,
      phoneNumber,
      email,
      nationality,
      group,
      age,
      studentAmplua,
      studentNumber,
      photo,
      placeholderPhoto,
      uploadPhoto,
      handlePhotoChange,
      hasNewPhoto,
      savePhoto,
      fileInput,
      inputValue,
      apiURL,
      infoBlocks,
      career,
      studentAttendedTrainings,
      studentMissedTrainings,
      planedTrainingsData,
      completedTrainingsByGroup,
      playerHealth,
      calculateBMI,
      attendanceCoeff,
      playerMatchTime,
      playerMatchSummaryStats,
      allSummaryStats,

      marks,
      chartKey,
      radarSettings,
      playerCurrentStatus,
      playerMatchPercent,

      averagePoints,
    }
  },

  components: {
    PositionsField,
    PlayerModel,
    TrainingCalendar,
    MiniSkeletonBack,
    MiniSkeletonFront,
    PieChartDashboard
  },

  data() {
    return {
      player_image: player_image,
      graph: graph,
      arrow: arrow,
      body: body,
      field: field,
      club: club,
      flag: flag,
      progress: progress,
      team_info: {
        group: "U-11",
        age: "11",
        position: "ПН",
        number: "23",
      },
      table: {
        header: [
          "матчів",
          "голів",
          "асист",
          "пен.",
          "автогол",
          "жовт.",
          "черв.",
          "трен.",
          "пропущ.",
        ],
        before_joining: {
          matches: 0,
          goals: 0,
          assists: 0,
          penalties: 0,
          auto_goals: 0,
          yellow_card: 0,
          red_cards: 0,
          trainings: 0,
          missed_trainings: 0,
        },
        after_joining: {
          matches: 100,
          goals: 11,
          assists: 10,
          penalties: 11,
          auto_goals: 11,
          yellow_card: 11,
          red_cards: 11,
          trainings: 11,
          missed_trainings: 11,
        },
        total: {
          matches: 100,
          goals: 11,
          assists: 10,
          penalties: 11,
          auto_goals: 11,
          yellow_card: 11,
          trainings: 11,
          missed_trainings: 11,
        },
      },

      personal_info: {
        first_name: "Mark",
        last_name: "Bertsyk",
        middle_name: "Vicotorovich",
        birth_date: "12.12.1990",
        phone_number: "+380662252243",
        email: "m.bertsyk@outlook.com",
        nationality: "UKR",
        city: "Kyiv",
        contract_expires: "20.12.2024",
      },
      finances: {
        expenses: 49_000,
        straight_expenses: 156_000,
        total_expense: 200_000,
      },
      testing: {
        absolute_speed: 17,
        starting_speed: 17,
        test_code: 12,
        rating: 5,
      },
      health: {
        blood_type: "O(I)-",
        cardiogram: "36",
        blood_pressure: "98/70",
        heart_rate: "72",
      },
      stats: {
        before_joining: {
          matches: 100,
          goals: 11,
          assists: 10,
          penalties: 11,
          auto_goals: 11,
          yellow_card: 11,
          trainings: 11,
          missed_trainings: 11,
        },
        after_joining: {
          matches: 100,
          goals: 11,
          assists: 10,
          penalties: 11,
          auto_goals: 11,
          yellow_card: 11,
          trainings: 11,
          missed_trainings: 11,
        },
        total: {
          matches: 100,
          goals: 11,
          assists: 10,
          penalties: 11,
          auto_goals: 11,
          yellow_card: 11,
          trainings: 11,
          missed_trainings: 11,
        },
      },
    };
  },
};
</script>

<style scoped>

input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
}

.main-tab__image-container {
  position: relative;
}

.main-tab__upload-icon {
  position: absolute;
  right: 4px;
  top: 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 2;
}

.main-tab__player-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}

.main-tab__save-photo {
  margin-top: 8px;
  padding: 6px 10px;
  border-radius: 8px;
  background: #c59014;
  color: #0f172a;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.1s ease;
}

.main-tab__save-photo:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.main-tab__save-photo:not(:disabled):active {
  transform: translateY(1px);
}
</style>